import { render, staticRenderFns } from "./StarboardFuelCharacteristics.vue?vue&type=template&id=5360788c&scoped=true"
import script from "./StarboardFuelCharacteristics.vue?vue&type=script&lang=js"
export * from "./StarboardFuelCharacteristics.vue?vue&type=script&lang=js"
import style0 from "./StarboardFuelCharacteristics.vue?vue&type=style&index=0&id=5360788c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5360788c",
  null
  
)

export default component.exports